import { CalendarCheck2, CalendarX2 } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { toneSoftClass } from './tone'

export function AvailabilityBadge({
  label,
  available,
  className,
}: {
  label: string
  available?: boolean
  className?: string
}) {
  const Icon = available === false ? CalendarX2 : CalendarCheck2

  return (
    <span
      className={cn(
        'inline-flex min-h-7 items-center gap-1.5 rounded-pill border px-2.5 text-xs font-medium',
        available === false ? toneSoftClass.neutral : toneSoftClass.ok,
        className,
      )}
    >
      <Icon className="size-3.5 shrink-0" aria-hidden />
      <span className="truncate">{label}</span>
    </span>
  )
}
